import { Mutation, Action } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Resolve } from 'vue-di';
import { SurveySessionValueModel } from '@trialcard/apigateway.models';
import SurveyModule from './survey';
import { Settings } from '~/services/settings';

export interface IEligibilityQuestions {
    surveySessionId: string;
    questionId: number;
    answerId: number;
}
@InjectModule({ stateFactory: true }, module)
export default class EligibilityModule extends InjectVuexModule {
    @Resolve
    public settings!: Settings;

    @Resolve
    public survey!: SurveyModule;

    public sppEligibilityData = [] as SurveySessionValueModel[];
    public hubEligibilityData = [] as SurveySessionValueModel[];
    public patientEligibilityData = [] as SurveySessionValueModel[];

    public isEligible = false;

    @Mutation
    public async updateSppEligibilityData(newEligibilityData: typeof EligibilityModule.prototype.sppEligibilityData) {
        this.sppEligibilityData = newEligibilityData;
    }
    @Mutation
    public async updateHubEligibilityData(newEligibilityData: typeof EligibilityModule.prototype.hubEligibilityData) {
        this.hubEligibilityData = newEligibilityData;
    }
    @Mutation
    public async updatePatientEligibilityData(newEligibilityData: typeof EligibilityModule.prototype.patientEligibilityData) {
        this.patientEligibilityData = newEligibilityData;
    }

    @Mutation
    public async updateIsEligible(isEligible: boolean) {
        this.isEligible = isEligible;
    }

    @Action({ rawError: true })
    public checkSppEligibility(): boolean {
        const correctAnswers = [
            +this.settings.answerId1Yes,
            +this.settings.answerId2Yes,
            +this.settings.answerId3No,
            +this.settings.answerId4Yes,
            +this.settings.answerId5No,
            +this.settings.answerId6Yes,
            +this.settings.answerId7Yes,
        ];

        const isEligible = this.sppEligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
        this.updateIsEligible(isEligible);
        return isEligible;
    }

    @Action({ rawError: true })
    public checkHubEligibility(): boolean {
        const correctAnswers = [
            +this.settings.hubAnswerId1Yes,
            +this.settings.hubAnswerId2Yes,
            +this.settings.hubAnswerId3No,
            +this.settings.hubAnswerId4Yes,
            +this.settings.hubAnswerId5No,
            +this.settings.hubAnswerId6Yes,
            +this.settings.hubAnswerId7Yes,
        ];

        const isEligible = this.hubEligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
        this.updateIsEligible(isEligible);
        return isEligible;
    }

    @Action({ rawError: true })
    public checkPatientEligibility(): boolean {
        const correctAnswers = [
            // +this.settings.patientAnswerId1Yes,
            // +this.settings.patientAnswerId2Yes,
            // +this.settings.patientAnswerId3No,
            // +this.settings.patientAnswerId4Yes,
            +this.settings.patientAnswerId5No,
            +this.settings.patientAnswerId6Yes,
            +this.settings.patientAnswerId7Yes,
        ];

        const isEligible = this.patientEligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
        this.updateIsEligible(isEligible);
        return isEligible;
    }
}
